import Vue from 'vue';

const shoppingCartModule = {
    namespaced: true,
    persistent: true,
    state: {
        data: {}
    },
    mutations: {
        addProductToShoppingCart (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            let productExternalId = payload.product.external_id;

            if (!state.data[userId]) {
                Vue.set(state.data, userId, {});
            }

            if (!state.data[userId][warehouseId]) {
                Vue.set(state.data[userId], warehouseId, {});
            }

            Vue.set(state.data[userId][warehouseId], productExternalId, payload.product);
        },
        addRecipientToShoppingCart (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;

            if (!state.data[userId]) {
                Vue.set(state.data, userId, {});
            }

            if (!state.data[userId][warehouseId]) {
                Vue.set(state.data[userId], warehouseId, {});
            }

            if (!state.data[userId][warehouseId]["_recipients"]) {
                Vue.set(state.data[userId][warehouseId], "_recipients", []);
            }

            let recipient = state.data[userId][warehouseId]["_recipients"]
                ?.find(recipient => recipient.address_id === payload.recipient.address_id);

            if (!recipient) {
                state.data[userId][warehouseId]["_recipients"].push(payload.recipient);
            }
        },
        removeProductFromCart (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            let productExternalId = payload.productExternalId;
            if (userId in state.data && warehouseId in state.data[userId] && productExternalId in state.data[userId][warehouseId]) {
                delete state.data[userId][warehouseId][productExternalId];
            }
        },
        clearProductsFromCart (state, payload) {
            const userId = payload.userId;
            const warehouseId = payload.warehouseId;
            if (!(userId in state.data) || !(warehouseId in state.data[userId])) {
                return;
            }

            const cart = state.data[userId][warehouseId];
            Object.keys(cart).forEach(productExternalId => {
                if ('external_id' in cart[productExternalId]) {
                    Vue.delete(cart, productExternalId);
                }
            });
        },
        removeProductsFromCart (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            if (userId in state.data && warehouseId in state.data[userId]) {
                delete state.data[userId][warehouseId];
            }
        },
        removeRecipientFromCart (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            let addressId = payload.addressId;
            if (userId in state.data && warehouseId in state.data[userId]) {
                let recipient = state.data[userId][warehouseId]["_recipients"]
                    ?.find(recipient => recipient.address_id === addressId);
                if (recipient) {
                    const index = state.data[userId][warehouseId]["_recipients"].indexOf(recipient);
                    state.data[userId][warehouseId]["_recipients"].splice(index, 1);
                }
            }
        },
        reset(state) {
            state.data = {}
        }
    },
    getters: {
        getData: state => {
            return state.data;
        },
        getProductsInShoppingCart: state => userId => {
            return state.data[userId];
        },
        getRecipientsInShoppingCart: state => userId => {
            return state.data[userId];
        }
    }
};

export default shoppingCartModule;
